export default __webpack_public_path__ + "static/media/puma-s.8271729c.jpg";